import { ShieldCheck, Handshake, TrendingDown, MapPin, Eye, Users } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import Seo from "../components/Seo";

export default function About() {
  const values = [
    { i: <ShieldCheck className="w-6 h-6" />, t: "Verified Inventory", d: "We personally inspect every property before it goes live. No unverified listings." },
    { i: <TrendingDown className="w-6 h-6" />, t: "Price Transparency", d: "We publish our fair-price assessment so you know whether the ask is reasonable." },
    { i: <Eye className="w-6 h-6" />, t: "Property Intelligence", d: "Property scores, locality insights and honest pros & cons for each listing." },
    { i: <Handshake className="w-6 h-6" />, t: "Human Assistance", d: "Real local experts help you shortlist and visit — quality over quantity." },
  ];
  return (
    <div>
      <Seo title="About Us | Faridabad Property Vault" description="We are Faridabad's personally verified property platform. Quality over quantity." />
      <section className="bg-indigo-900 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-20 text-center">
          <span className="inline-flex items-center gap-1.5 bg-indigo-800 text-xs font-semibold px-3 py-1.5 rounded-full mb-5"><ShieldCheck className="w-3.5 h-3.5" /> Faridabad Focused</span>
          <h1 className="font-heading text-3xl sm:text-5xl font-extrabold">Faridabad ki selected properties — personally verified, honestly priced.</h1>
          <p className="mt-5 text-indigo-100/90 text-lg">We are not a generic marketplace. We control our inventory, physically inspect properties, and evaluate them honestly so you don't have to browse thousands of random listings.</p>
        </div>
      </section>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {values.map((v) => (
            <div key={v.t} className="bg-white rounded-2xl border border-slate-200 p-6">
              <div className="w-12 h-12 rounded-xl bg-indigo-50 text-indigo-800 flex items-center justify-center">{v.i}</div>
              <h3 className="font-heading font-bold text-slate-900 mt-4">{v.t}</h3>
              <p className="text-sm text-slate-500 mt-2">{v.d}</p>
            </div>
          ))}
        </div>
        <div className="mt-14 text-center bg-slate-50 rounded-3xl p-10 border border-slate-100">
          <h2 className="font-heading text-2xl font-bold text-slate-900">Looking for a property in Faridabad?</h2>
          <p className="text-slate-500 mt-2">Let our team help you find and verify the right one.</p>
          <div className="flex flex-wrap gap-3 justify-center mt-6">
            <Link to="/properties"><Button className="bg-indigo-900 hover:bg-indigo-800">Browse Properties</Button></Link>
            <Link to="/book-site-visit"><Button variant="outline">Book a Site Visit</Button></Link>
          </div>
        </div>
      </div>
    </div>
  );
}
